/**
 * Establecer la información de los pictogramas.
 * 
 * @param Object state 
 * @param Array nextState 
 * @return void
 */
export function setProdSga2pictograms(state, nextState) {
    state.prodSga2pictograms = nextState;
}
